import { GoogleTagManager } from '@next/third-parties/google';

export const GtmComponent = () => (process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? (
  <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM} />
) : null);
